import { useRef, useCallback, DependencyList } from 'react';

import { useSafeLayoutEffect } from './useSafeLayoutEffect.js';

/**
 * React hook to persist any value between renders,
 * but keeps it up-to-date if it changes.
 * @see {@link https://github.com/chakra-ui/chakra-ui/blob/main/packages/hooks/src/use-callback-ref.ts}
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function useCallbackRef<T extends (...args: any[]) => unknown>(
  fn: T | undefined,
  deps: DependencyList = [],
): T {
  const ref = useRef(fn);

  useSafeLayoutEffect(() => {
    ref.current = fn;
  });

  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useCallback(((...args) => ref.current?.(...args)) as T, deps);
}
